{
  "queries.title": "Consultas",
  "queries.empty": "No hay consultas configuradas."
}
